import { all } from "redux-saga/effects";
import { watchOBUsersData } from "./OnBoarding/UserDetails";
import { watchOBAddressData } from "./OnBoarding/AddressDetails";
import { watchUserData } from "./User/User";
import { watchStoreData } from "./OnBoarding/Store";
import { watchStoreSyncProductsData } from "./OnBoarding/StoreSyncProducts";
import { watchProductsData } from "./OnBoarding/Products";
import { watchStoreSyncMetaData } from "./OnBoarding/StoreSyncMeta";
import { watchStoreSyncOrdersData } from "./OnBoarding/StoreSyncOrders";
import { watchProductsCountData } from "./OnBoarding/ProductsCount";
import { watchOrdersData } from "./OnBoarding/Orders";
import { watchFetchRatesData } from "./Order/Rates";
import { watchGetOrderData } from "./Order/GetOrder";
import { watchGetOrderTrackingData } from "./Tracking/OrderTracking";
import { watchFetchRatesByOrderData } from "./Order/RatesByOrder";
import { watchBuyPickupData } from "./PickUp/BuyPickup";
import { watchBuyLabelData } from "./Shipment/BuyLabel";
import { watchFetchShipmentOrderData } from "./Shipment/shipmentOrder";
import { watchPickupRateData } from "./PickUp/PickupRate";
import { watchDownloadLabelData } from "./Shipment/DownloadLabel";
import { watchCreateOrderData } from "./Order/CreateOrder";
import { watchAllAddressesData } from "./OnBoarding/AllAddresses";
import { watchGetEasyPostTrackingData } from "./Tracking/EasyPostTracking";
import { watchGetOrderCountData } from "./Order/OrderCount";
import { watchSkipChannelData } from "./OnBoarding/SkipChannel";
import { watchWareHouseData } from "./Utility/WareHouse";
import { watchCountryData } from "./Utility/Country";
import { watchGetOrderWithDetailsData } from "./Order/OrderWithProductDetails";
import { watchFetchQuickRatesData } from "./Order/QuickRates";
import { watchUpdateAddressData } from "./AddressManager/UpdateAddress";
import { watchGetAddressData } from "./AddressManager/GetAddress";
import { watchGetAddressByIdData } from "./AddressManager/GetAddressById";
import { watchUpdateAddressDefaultData } from "./AddressManager/UpdateAddressDefault";
import { watchUpdateAddressStatusData } from "./AddressManager/UpdateAddressStatus";
import { watchAddAddressData } from "./AddressManager/AddAddress";
import { watchShipmentFeesDetailsData } from "./Shipment/ShipmentFeesDetails";
import { watchGetAddressByCategoryData } from "./AddressManager/GetAddressByCategory";
import { watchPurchaseShipment } from "./Shipment/PurchaseShipment";
import { watchCustomerIssueData } from "./Support/Support";
import { watchFinishLaterData } from "./OnBoarding/FinishLater";
import { watchBatchOrdersData } from "./Shipment/BatchOrders";
import { watchGetBatchOrderCountData } from "./Shipment/BatchOrdersCount";
import { watchBatchShipmentDetailsData } from "./Shipment/BatchShipment";
import { watchCreateShipmentData } from "./Order/CreateShipment";
import { watchCancelOrderData } from "./Order/CancelOrder";
import { watchDownloadBatchLabelData } from "./Shipment/DownloadBatchLabel";
import { watchUploadFile } from "./Order/BulkUpload";
import { watchFetchFileStatus } from "./Order/BulkUploadInfo";
import { watchCreateWalletData } from "./Wallet/CreateWallet";
import { watchGetWalletDetailsData } from "./Wallet/GetWalletDetails";
import { watchGetShipmentCountData } from "./Shipment/ShipmentCount";
import { watchShipmentListData } from "./Shipment/ShipmentList";
import { watchShipmentNdrDetailsData } from "./Shipment/ShipmentNdr";
import { watchSearchShipmentData } from "./Shipment/SearchShipment";
import { watchGetStoreData } from "./OnBoarding/GetStoreData";
import { watchBatchOrdersByIdData } from "./Shipment/GetBatchByBatchId";
import { watchDownloadBatchErrorData } from "./Shipment/DownloadError";
import { watchDownloadBatchStatus } from "./Shipment/DownloadBatchStatus";
import { watchGetPackageBoxesData } from "./Configuration/GetPackageBoxes";
import { watchaddPackageBoxesData } from "./Configuration/AddPackageBox";
import { watchUpdatePackageBoxesData } from "./Configuration/UpdatePackageBox";
import { watchActivityLogData } from "./Order/ActivityLog";
import { watchGetChannelData } from "./ChannelConfig/GetChannelData";
import { watchSaveChannelData } from "./ChannelConfig/SaveChannelData";
import { watchUpdateChannelData } from "./ChannelConfig/UpdateChannelData";
import { watchGetBulkActionslistData } from "./BulkActions/BulkActionList";
import { watchSendBulkLabelData } from "./BulkActions/CreateBulkLabel";
import { watchGetBulkLabelDownloadData } from "./BulkActions/BulkLabelDownlod";
import { watchGetBulkErrorDownloadData } from "./BulkActions/BulkErrorDownload";
import { watchDownloadBulkStatus } from "./BulkActions/BulkDownloadStatus";
import { watchGetBulkOrderCountData } from "./BulkActions/BulkOrdersCount";
import { watchCreateShipmentLabelData } from "./ShipmentLabel/AddShipmentLabel";
import { watchGetShipmentLabelData } from "./ShipmentLabel/GetShipmentLabel";
import { watchUpdateEmailNotificationData } from "./Notification/UpdateEmailNotification";
import { watchGetEmailNotificationData } from "./Notification/getEmailNotification";
import { watchUpdateWhatsappNotificationData } from "./Notification/UpdateWhatsappNotification";
import { watchGetWhatsappNotificationData } from "./Notification/getWhatsappNotification";
import { watchUploadWeightDiscrepancyFile } from "./AdminPanel/UploadWeightDiscrepancy";
import { watchUploadCodRemittanceFile } from "./AdminPanel/UploadCodRemittance";
import { watchGetOrderByStatusData } from "./Order/GetOrdersByStatus";
import { watchGetWhatsappSummaryData } from "./Notification/getWhatsappSummary";
import { watchEnableWhatsappNotificationData } from "./Notification/EnableWhatsappNotification";
import { watchCreateWhatsappTrialMessageData } from "./Notification/CreateTrialMessage";
import { watchUploadBrandImage } from "./Notification/UploadBrandImage";
import { watchGetMessageCountData } from "./Notification/GetMessageCount";
import { watchGetOrderByStatusCountData } from "./Order/GetOrdersByStatusCount";
import { watchMarkRtoReceivedData } from "./Order/MarkRtoReceived";
import { watchInvoicingLogData } from "./AdminPanel/GetInvoicingDetails";
import { watchFetchInvoicingReportDownloadData } from "./AdminPanel/InvoicingFileDownload";
import { watchFinalChargesLogData } from "./AdminPanel/GetFinalChargesDetails";
import { watchFetchFinalChargesReportDownloadData } from "./AdminPanel/FinalChargesFileDownload";
import { watchUpdateUtrNumberData } from "./AdminPanel/UpdateUtrNumber";
import { watchGetRateConfigsData } from "./RateManagement/GetRateConfigs";
import { watchGetDefaultCarriersData } from "./RateManagement/GetDefaultCarriers";
import { watchSaveDefaultCarriersData } from "./RateManagement/SaveDefaultCarriers";
import { watchSendRateConfigsData } from "./RateManagement/SendRateConfigs";
import { watchGetZoneRateFileData } from "./RateManagement/GetZoneRateFile";
import { watchGetZoneMappingFileData } from "./RateManagement/GetZoneMappingFile";
import { watchUploadZoneMappingFileData } from "./RateManagement/UploadZoneMappingFile";
import { watchUploadZoneRateFileData } from "./RateManagement/UploadZoneRateFile";
import { watchGetActiveCarriersData } from "./RateManagement/GetActiveCarriers";
import { watchFetchTenantListData } from "./OnBoarding/TenantList";
import { watchGenerateShipmentChargesData } from "./AdminPanel/GenerateShipmentCharges";
import { watchGenerateFinalChargesData } from "./AdminPanel/GenerateFinalCharges";
import { watchTenantManagerLogData } from "./TenantManager/TenantManagerLog";
import { watchUpdateAdminRechargeData } from "./TenantManager/AdminRecharge";
import { watchAddTagsData } from "./Order/AddTags";
import { watchGetRiskScoreChargesData } from "./VasCharges/getRiskScoreCharges";
import { watchGetWhatsappChargesData } from "./VasCharges/getWhatsappCharges";
import { watchGetWhatsappConfirmationChargesData } from "./VasCharges/getWhatsappConfirmationCharges";
import { watchUpdateWhatsappChargesData } from "./VasCharges/updateWhatsappCharges";
import { watchUpdateRiskScoreCharges } from "./VasCharges/updateRiskScoreCharges";
import { watchUpdateWhatsappConfirmationChargesData } from "./VasCharges/updateWhatsappConfirmationCharges";
import { watchUpdateVasControlData } from "./VasCharges/updateVasControlData";
import { watchGetVasControlData } from "./VasCharges/getVasControlData";
import { watchUpdateWhatsappNotificationChargesData } from "./VasCharges/updateWhatsappNotificationCharges";
import { watchGetWeightImageDownloadData } from "./WeightDiscrepancy/DownloadWeightDisputeImage";
import { watchGetWeightDiscrepancyAggregateData } from "./WeightDiscrepancy/GetWeightDiscrepancyAggregate";
import { watchGetWeightDiscrepancyData } from "./WeightDiscrepancy/GetWeightDiscrepancyData";
import { watchUpdateWeightDispute } from "./WeightDiscrepancy/UpdateWeightDispute";
import { watchWeightDisputeFileUpload } from "./WeightDiscrepancy/WeightDisputeUpload";
import { watchCloseWeightDiscrepancyData } from "./WeightDiscrepancy/CloseWeightDispute";
import { watchWalletPlansData } from "./TenantManager/GetSellerWalletPlans";
import { watchActivePlanData } from "./TenantManager/GetActiveWalletPlan";
import { watchUpdateWalletPlanData } from "./TenantManager/UpdateSellerWalletPlan";
import { watchGetProfileData } from "./OnBoarding/GetProfile";
import { watchFetchUpdateKYCstateData } from "./OnBoarding/UpdateKYCstate";
import { watchFetchBillingDatesData } from "./AdminPanel/BillingDates";
import { watchActiveAccountTypeData } from "./TenantManager/GetAccountType";
import { watchUpdateActiveAccountData } from "./TenantManager/UpdateAccountType";
import { watchGetEarlyCODChargesData } from "./VasCharges/getEarlyCODCharges";
import { watchUpdateEarlyCODCharges } from "./VasCharges/updateEarlyCODCharges";
import { watchGetRemittancePayoutCycle } from "./TenantManager/GetRemittancePayoutCycle";
import { watchUpdateRemittancePayoutCycle } from "./TenantManager/UpdateRemittancePayoutCycle";
import { watchGetWhatsappNdrVerificationChargesData } from "./VasCharges/getWhatsappNdrVerificationCharges";
import { watchUpdateWhatsappNdrVerificationChargesData } from "./VasCharges/updateWhatsappNdrVerificationCharges";
import { watchGetBulkWeightDiscrepancyData } from "./WeightDiscrepancy/GetBulkWeightDiscrepancyData";
import { watchGetBulkWeightDiscrepancyCount } from "./WeightDiscrepancy/GetBulkWeightDiscrepancyCount";
import { watchUploadImageByCarrier } from "./WeightDiscrepancy/UploadImageByCarrier";
import { watchGetIVRNDRChargesChargesData } from "./VasCharges/getIVRndrCharges";
import { watchGetIVRORDERChargesChargesData } from "./VasCharges/getIVRorderCharges";
import { watchDeactivateVasControlData } from "./VasCharges/deactivateVasService";
import { watchGetOTPverifiedDeliveryChargesData } from "./VasCharges/getOtpVerifiedDeliveryCharges";
import { watchGetErrorFileDownloadData } from "./AdminPanel/DownloadErrorFile";
import { watchCarrierListData } from "./RateCard/GetCarrierList";
import { watchRateListData } from "./RateCard/GetRates";
import { watchFetchPaymentReportDownloadData } from "./Payment/RequestReportDownload";
import { watchUpdateB2BMisData } from "./B2BMis.tsx/UpdateB2BMis";
import { watchCompanyMetaData } from "./TenantManager/GetCompanyMetaData";
import { watchKycInfo } from "./TenantManager/GetKycInfo";
import { watchGetDeclarationForm } from "./OnBoarding/DownloadDeclarationForm";
import { watchFetchUpdateDeclarationFormstateData } from "./OnBoarding/UpdateDeclarationStatus";
import { watchGetDeclarationStatus } from "./OnBoarding/GetDeclarationStatus";
import { watchOnGstCertList } from "./OnBoarding/GetGSTcertList";
import { watchGetPendingRechargeRequests } from "./RechargeApproval/GetPendingRechargeRequests";
import { watchGetDecidedRechargeRequests } from "./RechargeApproval/GetDecidedRechargeRequests";
import { watchApproveRecharge } from "./RechargeApproval/ApproveRecharge";
import { watchRejectRecharge } from "./RechargeApproval/RejectRecharge";
import { watchGetApprovers } from "./RechargeApproval/GetApprovers";
import { watchAddApprover } from "./RechargeApproval/AddApprover";
import { watchRemoveApprover } from "./RechargeApproval/RemoveApprover";
import { watchGetUserInfo } from "./User/GetUserInfo";
import { watchGetCompanyInfo } from "./TenantManager/GetCompanyInfo";
/**
 * rootSaga
 */
export default function* root() {
    yield all([
        watchOBUsersData(),
        watchOBAddressData(),
        watchUserData(),
        watchStoreData(),
        watchStoreSyncOrdersData(),
        watchStoreSyncProductsData(),
        watchStoreSyncMetaData(),
        watchFinishLaterData(),
        watchProductsData(),
        watchProductsCountData(),
        watchFetchRatesData(),
        watchOrdersData(),
        watchGetOrderData(),
        watchGetOrderTrackingData(),
        watchFetchRatesByOrderData(),
        watchBuyPickupData(),
        watchBuyLabelData(),
        watchFetchShipmentOrderData(),
        watchPickupRateData(),
        watchDownloadLabelData(),
        watchCreateOrderData(),
        watchAllAddressesData(),
        watchGetEasyPostTrackingData(),
        watchGetOrderCountData(),
        watchSkipChannelData(),
        watchCountryData(),
        watchWareHouseData(),
        watchShipmentFeesDetailsData(),
        watchGetOrderWithDetailsData(),
        watchPurchaseShipment(),
        watchFetchQuickRatesData(),
        watchAddAddressData(),
        watchUpdateAddressData(),
        watchGetAddressData(),
        watchGetAddressByIdData(),
        watchUpdateAddressDefaultData(),
        watchUpdateAddressStatusData(),
        watchGetAddressByCategoryData(),
        watchCustomerIssueData(),
        watchBatchOrdersData(),
        watchGetBatchOrderCountData(),
        watchBatchShipmentDetailsData(),
        watchCreateShipmentData(),
        watchCancelOrderData(),
        watchDownloadBatchLabelData(),
        watchUploadFile(),
        watchFetchFileStatus(),
        watchCreateWalletData(),
        watchGetWalletDetailsData(),
        watchGetShipmentCountData(),
        watchShipmentListData(),
        watchShipmentNdrDetailsData(),
        watchSearchShipmentData(),
        watchGetStoreData(),
        watchBatchOrdersByIdData(),
        watchDownloadBatchErrorData(),
        watchDownloadBatchStatus(),
        watchGetPackageBoxesData(),
        watchaddPackageBoxesData(),
        watchUpdatePackageBoxesData(),
        watchActivityLogData(),
        watchGetChannelData(),
        watchSaveChannelData(),
        watchUpdateChannelData(),
        watchGetBulkActionslistData(),
        watchSendBulkLabelData(),
        watchGetBulkLabelDownloadData(),
        watchGetBulkErrorDownloadData(),
        watchDownloadBulkStatus(),
        watchGetBulkOrderCountData(),
        watchCreateShipmentLabelData(),
        watchGetShipmentLabelData(),
        watchUpdateEmailNotificationData(),
        watchGetEmailNotificationData(),
        watchUpdateWhatsappNotificationData(),
        watchGetWhatsappNotificationData(),
        watchUploadWeightDiscrepancyFile(),
        watchUploadCodRemittanceFile(),
        watchGetOrderByStatusData(),
        watchGetWhatsappSummaryData(),
        watchEnableWhatsappNotificationData(),
        watchCreateWhatsappTrialMessageData(),
        watchUploadBrandImage(),
        watchGetMessageCountData(),
        watchGetOrderByStatusCountData(),
        watchMarkRtoReceivedData(),
        watchInvoicingLogData(),
        watchFetchInvoicingReportDownloadData(),
        watchFinalChargesLogData(),
        watchFetchFinalChargesReportDownloadData(),
        watchUpdateUtrNumberData(),
        watchGetRateConfigsData(),
        watchGetDefaultCarriersData(),
        watchSaveDefaultCarriersData(),
        watchSendRateConfigsData(),
        watchGetZoneRateFileData(),
        watchGetZoneMappingFileData(),
        watchUploadZoneMappingFileData(),
        watchUploadZoneRateFileData(),
        watchGetActiveCarriersData(),
        watchFetchTenantListData(),
        watchGenerateShipmentChargesData(),
        watchGenerateFinalChargesData(),
        watchTenantManagerLogData(),
        watchUpdateAdminRechargeData(),
        watchAddTagsData(),
        watchGetRiskScoreChargesData(),
        watchGetWhatsappChargesData(),
        watchGetWhatsappConfirmationChargesData(),
        watchUpdateRiskScoreCharges(),
        watchUpdateWhatsappChargesData(),
        watchUpdateWhatsappConfirmationChargesData(),
        watchGetVasControlData(),
        watchUpdateVasControlData(),
        watchUpdateWhatsappNotificationChargesData(),
        watchGetWeightDiscrepancyData(),
        watchGetWeightDiscrepancyAggregateData(),
        watchWeightDisputeFileUpload(),
        watchUpdateWeightDispute(),
        watchGetWeightImageDownloadData(),
        watchCloseWeightDiscrepancyData(),
        watchWalletPlansData(),
        watchActivePlanData(),
        watchUpdateWalletPlanData(),
        watchGetProfileData(),
        watchFetchUpdateKYCstateData(),
        watchFetchBillingDatesData(),
        watchActiveAccountTypeData(),
        watchUpdateActiveAccountData(),
        watchGetEarlyCODChargesData(),
        watchUpdateEarlyCODCharges(),
        watchGetRemittancePayoutCycle(),
        watchUpdateRemittancePayoutCycle(),
        watchGetWhatsappNdrVerificationChargesData(),
        watchUpdateWhatsappNdrVerificationChargesData(),
        watchGetBulkWeightDiscrepancyData(),
        watchGetBulkWeightDiscrepancyCount(),
        watchUploadImageByCarrier(),
        watchGetIVRNDRChargesChargesData(),
        watchGetIVRORDERChargesChargesData(),
        watchDeactivateVasControlData(),
        watchGetOTPverifiedDeliveryChargesData(),
        watchGetErrorFileDownloadData(),
        watchCarrierListData(),
        watchRateListData(),
        watchFetchPaymentReportDownloadData(),
        watchUpdateB2BMisData(),
        watchCompanyMetaData(),
        watchKycInfo(),
        watchGetDeclarationForm(),
        watchFetchUpdateDeclarationFormstateData(),
        watchGetDeclarationStatus(),
        watchOnGstCertList(),
        watchGetPendingRechargeRequests(),
        watchGetDecidedRechargeRequests(),
        watchApproveRecharge(),
        watchRejectRecharge(),
        watchGetApprovers(),
        watchAddApprover(),
        watchRemoveApprover(),
        watchGetUserInfo(),
        watchGetCompanyInfo(),
    ]);
}
